import { NavItem } from '@app/core/models/nav-item';

export class NavTabService {
    navItems: NavItem[];
    active: number;
    resultWidth: string;

    constructor() {
        this.navItems = this._initNavTab();
        this.resultWidth = 100 / this.navItems.length + '%';
        this.active = 0;
    }

    setActiveTab(key: string) {
        for (let index = 0; index < this.navItems.length; index++) {
            const navItem = this.navItems[index];
            if (navItem.key === key) {
                this.active = index;
                if (!navItem.disabled) {
                    navItem.disabled = true;
                }
            } else {
                navItem.disabled = false;
            }
        }
    }

    private _initNavTab(): NavItem[] {
        return [
            new NavItem(
                'profile',
                'My Profile',
                true,
                'journey/profile',
                false
            ),
            new NavItem(
                'coverage',
                'My Coverage',
                false,
                'journey/coverage',
                false
            ),
            new NavItem(
                'needs',
                'My Needs',
                false,
                'journey/my-needs',
                false
            ),
            new NavItem(
                'submit',
                'Submit',
                false,
                'journey/submit',
                false
            )];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/navTab.service.ts